import React, { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

import { MASK_DEFINITIONS } from '../../utils/formatters';

/**
 * MUI ⇄ react-imask adapter (the pattern from MUI's TextField docs), for
 * `slotProps.input.inputComponent`. The field shows the masked text, but the
 * form state receives the raw (unmasked) value through `onChange`, so it is
 * stored and sent without punctuation. Use `maskedInputSlotProps(mask)`.
 */
const MaskedInput = forwardRef(function MaskedInput({ onChange, value, mask, name, ...other }, ref) {
  return (
    <IMaskInput
      {...other}
      name={name}
      mask={mask}
      definitions={MASK_DEFINITIONS}
      prepareChar={(char) => char.toUpperCase()}
      // With `unmask`, `value` in and `onAccept` out are both the raw value.
      unmask
      value={value ?? ''}
      inputRef={ref}
      // Only user input (which carries the event) reaches the form state: a
      // programmatic re-mask must never rewrite the stored value.
      onAccept={(unmasked, maskRef, event) => {
        if (event && unmasked !== (value ?? '')) onChange({ target: { name, value: unmasked } });
      }}
      overwrite={false}
    />
  );
});

/**
 * `slotProps` for a masked MUI TextField; without a mask (e.g. no mask for
 * the data's country) the field stays a plain input. Merge `htmlInput` with
 * any other input attributes (e.g. maxLength) you pass.
 */
export const maskedInputSlotProps = (mask, htmlInput) =>
  mask ? { input: { inputComponent: MaskedInput }, htmlInput: { ...htmlInput, mask } } : { htmlInput };

export default MaskedInput;
